import { render, staticRenderFns } from "./EditPwd.vue?vue&type=template&id=2b25dace&scoped=true&"
import script from "./EditPwd.vue?vue&type=script&lang=js&"
export * from "./EditPwd.vue?vue&type=script&lang=js&"
import style0 from "./EditPwd.vue?vue&type=style&index=0&id=2b25dace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b25dace",
  null
  
)

export default component.exports